module.exports = __webpack_public_path__ + "img/front_water_normal.232553ae.png";